"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-5 w-24 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-28 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted/30 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-foreground-dark hover:text-primary hover:scale-[1.03] transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] text-sm font-medium">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const socials = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }];
  return <footer className="relative w-full bg-dark-background text-foreground-dark py-12 px-6 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-primary/10 via-transparent to-secondary/10 pointer-events-none" aria-hidden="true" />

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 mb-8">
          {}
          <div className="animate-fade-in-up">
            <h3 className="text-lg font-display font-semibold mb-4 text-primary">
              Quick Links
            </h3>
            <MenuProvider menu_id="26">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="animate-fade-in-up-delay-100">
            <h3 className="text-lg font-display font-semibold mb-4 text-primary">
              Follow Us
            </h3>
            <div className="flex gap-4">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.href} data-index={i} newTab aria-label={social.label} className="flex items-center justify-center w-10 h-10 rounded-full bg-muted-dark-background hover:bg-primary hover:scale-[1.03] transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] group">
                    <Icon className="w-5 h-5 text-foreground-dark group-hover:text-foreground-primary transition-colors" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        {}
        <div className="text-center pt-8 border-t border-border/20">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Pro Marketing. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}